const GerenciamentoOperadores = () =>
  import(/* webpackChunkName: "group-callcenter" */ '../_views/GerenciamentoOperadores')

export default [
  {
    path: 'operadores',
    meta: {
      requiresAuth: true,
      permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_CALLCENTER_MANUTENCAO_VISUALIZAR],
    },
    component: GerenciamentoOperadores,
    name: 'GerenciaOperadores',
  },
]
